//------------- REACT IMPORT ---------------//
import { faArrowCircleLeft, faBriefcaseMedical, faChevronRight, faFileInvoice, faListCheck, faLongArrowLeft, faPowerOff, faUser, faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Drawer_profile, LeftIcon } from "../../../assets/images";
import { Image } from "react-bootstrap";

function DrawerComponent(props) {

    return (
        <div>
            {[false].map((expand, show) => (
                <Navbar key={expand} bg="light" direction="left" targetId="drawer" expand={props.show} className="mb-1">
                    <Container fluid>
                        {/* <Navbar.Brand href="#">Navbar Offcanvas</Navbar.Brand> */}
                        {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} /> */}
                        <Navbar.Offcanvas
                            id={`offcanvasNavbar-expand-${expand}`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                            placement="end"
                        >
                            <Offcanvas.Header>
                                {/* <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}> */}
                                <div className="icon_top" >
                                    <a href="javascript:;">  <Image src={LeftIcon} alt="..." /></a>
                                </div>
                                <div className="profile_info">
                                    <div className="img_area">
                                        <Image src={Drawer_profile} alt="..." />
                                    </div>
                                    <h5>William Victoria</h5>
                                    <p>Super Admin</p>
                                </div>
                                {/* </Offcanvas.Title> */}
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <div className="content_area">
                                    <div className="left_area" onClick={props.close}>
                                        <p>Oxford Hospital</p>
                                    </div>
                                    <div className="right_area">
                                        <a href="javascript:;" className="btn btn-primary">Change</a>
                                    </div>
                                </div>
                                <div className="list_area">
                                    <ul>
                                        <li className="active"><a href="javascript:;">
                                            <div className="text_icon_area">
                                                <div className="left_icon">
                                                    <div className="icon_box">
                                                        <FontAwesomeIcon icon={faBriefcaseMedical} />
                                                    </div>
                                                </div>
                                                <div className="right_text">
                                                    <p>Manage Hospitals</p>
                                                </div>
                                            </div>
                                        </a></li>
                                        <li><a href="javascript:;">
                                            <div className="text_icon_area">
                                                <div className="left_icon">
                                                    <div className="icon_box">
                                                        <FontAwesomeIcon icon={faUserGroup} />
                                                    </div>
                                                </div>
                                                <div className="right_text">
                                                    <p>Manage Staff</p>
                                                </div>
                                            </div>
                                        </a></li>
                                        <li><a href="javascript:;">
                                            <div className="text_icon_area">
                                                <div className="left_icon">
                                                    <div className="icon_box">
                                                        <FontAwesomeIcon icon={faUser} />
                                                    </div>
                                                </div>
                                                <div className="right_text">
                                                    <p>Manage Patient</p>
                                                </div>
                                            </div>
                                        </a></li>
                                        <li><a href="javascript:;">
                                            <div className="text_icon_area">
                                                <div className="left_icon">
                                                    <div className="icon_box">
                                                        <FontAwesomeIcon icon={faListCheck} />
                                                    </div>
                                                </div>
                                                <div className="right_text">
                                                    <p>Manage Tasks</p>
                                                </div>
                                            </div>
                                        </a></li>
                                        <li><a href="javascript:;">
                                            <div className="text_icon_area">
                                                <div className="left_icon">
                                                    <div className="icon_box">
                                                        <FontAwesomeIcon icon={faFileInvoice} />
                                                    </div>
                                                </div>
                                                <div className="right_text">
                                                    <p>Manage Roles</p>
                                                </div>
                                            </div>
                                        </a></li>
                                        <li><a href="javascript:;">
                                            <div className="text_icon_area">
                                                <div className="left_icon">
                                                    <div className="icon_box">
                                                        <FontAwesomeIcon icon={faPowerOff} />
                                                    </div>
                                                </div>
                                                <div className="right_text">
                                                    <p>Log Out</p>
                                                </div>
                                            </div>
                                        </a></li>
                                    </ul>
                                </div>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            ))}
        </div>
    );
}

export default DrawerComponent;
